// Walks the document once on load and wraps any bare "©" in a <sup> so it
// renders as an exponent, matching the treatment already hard-coded in a few
// templates (e.g. the contact form's "VS/Goods<sup>©</sup>"). A "©" that is
// already the sole content of a <sup> is left untouched.

const SYMBOL = "©";
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"]);

function alreadySuperscript(textNode) {
  const parent = textNode.parentNode;
  return (
    parent &&
    parent.nodeName === "SUP" &&
    parent.textContent.trim() === SYMBOL
  );
}

function wrapTextNode(textNode) {
  const text = textNode.nodeValue;
  const frag = document.createDocumentFragment();
  let last = 0;

  for (let i = text.indexOf(SYMBOL); i !== -1; i = text.indexOf(SYMBOL, i + 1)) {
    if (i > last) {
      frag.appendChild(document.createTextNode(text.slice(last, i)));
    }
    const sup = document.createElement("sup");
    sup.textContent = SYMBOL;
    frag.appendChild(sup);
    last = i + 1;
  }

  if (last < text.length) {
    frag.appendChild(document.createTextNode(text.slice(last)));
  }

  textNode.parentNode.replaceChild(frag, textNode);
}

export default function superscriptCopyright(root = document.body) {
  if (!root) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || node.nodeValue.indexOf(SYMBOL) === -1) {
        return NodeFilter.FILTER_REJECT;
      }
      if (SKIP_TAGS.has(node.parentNode?.nodeName)) {
        return NodeFilter.FILTER_REJECT;
      }
      if (alreadySuperscript(node)) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const targets = [];
  while (walker.nextNode()) targets.push(walker.currentNode);
  targets.forEach(wrapTextNode);
}
